export default function MenuItem(theme) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
          },
          "&.Mui-selected:hover": {
            backgroundColor: theme.palette.primary.dark,
          },
        },
      },
    },
  };
}